<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">Access Tokens</h5>
            </div>

            <form>
                <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="access_token">{{localizationStore.translate('access.token.name') }}</label>
                                <select id="access_token" names="access_token" class="form-control" v-model="token_name">
                                    <option v-for="(token,index) in token_names" :value="token">{{token}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="tokens_scope">{{ localizationStore.translate('access.token.scope') }}</label>
                                <select id="tokens_scope" name="tokens_scope" class="form-control" v-model="token_scope">
                                    <option v-for="(scope, index) in token_scopes" :value="scope.id">{{ scope.description }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-primary mx-auto my-auto" @click="createToken">Create Token Changes</button>
                <button
                    type="button"
                    class="btn btn-outline-primary ml-1"
                    @click="isPlayerActive = !isPlayerActive"
                >
                    <vue-feather size="12" type="film" />
                    Tutorial
                </button>
            </form>
            <div class="row mt-2">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <h4 v-if="Object.keys(access_tokens).length">API Key List & Access</h4>
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-sm-12"
                            style="background: #eceeef; padding: 14px; position: relative;margin-bottom: 6px;border-radius: 4px;"
                            v-for="(token, index) in access_tokens"
                        >
                        <h5 style="padding-bottom: 7px;">
                            {{token.name}}
                            <span class="badge bg-light-success font-sm"
                                style="font-size: 12px;font-weight: 200;">{{token.revoked ?'Revoked':'Active'}}</span>
                        </h5>
                        <!-- this is action -->
                        <a
                            class="btn btn-sm dropdown-toggle hide-arrow"
                            data-toggle="dropdown"
                            style="position: absolute; top: 20px;right: 20px;"
                        >
                            <vue-feather class="font-small-4" type="more-vertical" style="width:16px"></vue-feather>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a
                                href="javascript:;"
                                class="dropdown-item"
                                @click="showDeleteRevokeAlert(token.id)"
                            >
                                <vue-feather class="font-small-4" type="trash-2" style="width:16px"></vue-feather> Delete
                            </a>
                        </div>
                        <!-- end of action -->
                                <div class="input-group " style="box-shadow: 0 0px 0px 0 rgb(34 41 47 / 10%) !important;" v-if="token.token">
                                    <div id="company-url" type="text" class="form-control col-4"  style=" background: #eceeef;border: 0px;font-weight: bolder;overflow: hidden;line-height: 30px;" >{{token.token}}</div>
                                    <div class="input-group-append" style="border-radius: 4px;">
                                        <button class="btn btn-outline-primary"
                                        data-clipboard-target="#company-url"
                                        type="button" data-toggle="tooltip"
                                        data-placement="top"
                                        :title="tooltipData"
                                        @click="copyToken(token.token)"
                                        style="border-radius: 4px;border: 0px !important;background: #dfdfdf;">
                                            copy
                                        </button>
                                    </div>
                                </div>
                                <div class="col-lg-4" v-else>
                                    <div class="no-token-value">*********************</div>
                                </div>
                                <p style="padding-top: 12px;">Created At {{formartDate(token.created_at)}}</p>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div ref="reference" style="opacity:0%">
        <textarea type="text" class="form-control" style="height: 3px;width: 100%;overflow: hidden;overflow-wrap: break-word;background: #4b9a5e;border: 0px;color:white" col="40" row="10" ref="access_token_copy" v-model="token">
            <!-- {{ token }} -->
        </textarea>
    </div>
    <sweet-delete-alert v-if="revokeStatus == true">
        <template #delete_title>
            Are you sure you want to delete this?
        </template>
        <template #delete_message>
            You won't be able to revert this!
        </template>
        <template #actionsBtn>
            <div class="swal2-actions">
                <div class="swal2-loader"></div>
                <button type="button" class="swal2-confirm btn btn-primary" style="disp2lay: inline-block;" aria-label="" v-on:click="revoke()">Yes, Delete Client. </button>
                <button type="button" class="swal2-deny mr-10" style="display: none;" aria-label="">No</button>&nbsp;&nbsp;&nbsp;
                <button type="button" class="swal2-cancel btn btn-outline-danger ms-1" style="display: inline-block;" aria-label="sweetAlertDelete" @click="showDeleteRevokeAlert()">Cancel</button>
            </div>
        </template>
    </sweet-delete-alert>
    <div
        v-if="isPlayerActive"
        class="modal fade text-left show"
        tabindex="-1"
        aria-labelledby="myModalLabel17"
        aria-modal="true"
        role="dialog"
        style="padding-right: 15px;display:block;background: #000000b5;"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="isPlayerActive = !isPlayerActive">
                        <span aria-hidden="true" >×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <iframe
                            :src="businessStore.tutorials.accessToken"
                            style="margin:auto;height: 66vh;width: 100%;"
                            width="560"
                            height="315"
                            title="Creditfixrr Access Token Tutorial"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { VueGoodTable } from 'vue-good-table-next'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import SweetDeleteAlert from '../../../Components/SweetDeleteAlert.vue'

import moment from 'moment'
import axios from 'axios'
export default{
    components:{
        vSelect,
        VueGoodTable,
        SweetDeleteAlert,
    },
    setup(){
        const limit=5,
        reference = ref(),
        token_name = ref(),
        token_names = ['Clixlo','GoHighLevel','Connectally','Other'],
        token_scope = ref(),
        token_scopes = ref([]),
        token = ref(),
        open_access_token = ref(),
        access_token_copy = ref(),
        isLoading = false,
        access_tokens = ref([]),
        revokeStatus = ref(false);
        return{
            isLoading,limit,token_name,token_names,token_scope,token_scopes,access_tokens,token,open_access_token,access_token_copy,revokeStatus,reference,
            localizationStore : useLocalizationStore(),
            businessStore: useBusinessStore(),
            isPlayerActive: ref(false)
        }
    },
    data(){
        return{
            currentPage: '',
        }
    },
    watch: {
    },
    mounted(){
        const route = this.$router.resolve(
            {
                name:"personal-access-tokens",
                query: { page: '1' }
            }
        );
        this.currentPage = route.href
        this.getScopes();
        this.getUsersAccessToken(this.currentPage,1);

    },
    methods:{
        createToken(){
            const data= {
                token_name:this.token_name,
                token_scope:this.token_scope,
            }
            const route = this.$router.resolve(
                {
                    name: 'create-access-token',
                }
            );
            axios.post(route.href,data).then(({data})=>{
                if(data.error == false){
                    // $this.access_tokens
                    let newdata = data.data,
                    token_value = newdata.token,
                    token_data = newdata.token_data,
                    new_token_data =  Object.assign(token_data, { token: token_value } )
                    let itemName = token_data.name,
                    filteredPTokens = this.access_tokens.filter((item) => item.name !== itemName);
                    filteredPTokens.push(new_token_data);
                    this.access_tokens = filteredPTokens;

                }else{
                    toastr.error(data.message,'Error')
                }
            })
        },
        selectMode(val){
            this.mode = val
        },
        getScopes(){
            const route = this.$router.resolve(
                {
                    name: "passport-scopes-index"
                }
            );
            axios.get(route.href).then(({data}) => {
                if(data != "" || data != undefined || data != null){
                    this.token_scopes = data
                }
            });
        },
        getUsersAccessToken(uri,page){
            this.page++;
            let $this = this,url;

            if(page == null || page == undefined){
                this.currentPage = uri + '?page=1&limit='+this.limit;
            }else{
                this.currentPage = uri + '&limit='+this.limit
            }
            this.isLoading = true
            axios.get(this.currentPage)
            .then(({data}) => {
                if(data.error != true){
                    $this.isLoading = false
                    const newdata  = data.data
                    $this.access_tokens = newdata
                }
            });
        },
        copyToken(value){
            this.token = 'Bearer '+value;
            setTimeout(()=>{
                this.$refs.access_token_copy.select();
                document.execCommand('copy');
                toastr.success('Access Token copied!','copied');
            },2000)

        },
        formartDate(date){
            return moment(date).format('llll');
        },
        showDeleteRevokeAlert(id){
            if(id != null ){
                this.tochangedata = {
                    'id' : id,
                }
            }else{
                this.tochangedata = {}
            }
            if(this.revokeStatus == true){
                this.revokeStatus = false
            }else{
                this.revokeStatus = true
            }
        },
        revoke(){
            const $this=this;
            let route;
            route = this.$router.resolve(
                {
                    name:"delete-access-token",
                    params: {
                        tokenId: $this.tochangedata.id
                    }
                }
            )
            axios.delete(route.href).then(({data})=>{
                if(data.error != true){
                    toastr.success('Access Token Deleted!','Delete Token');
                    $this.tochangedata = {}
                    $this.showDeleteRevokeAlert();
                    $this.reloadTable()
                    return;
                }else{
                    toastr.error('An Error Occured!','Delete Token');
                    return;
                }
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Delete Token!');
            });
        },
        reloadTable(){
            this.getUsersAccessToken(this.currentPage, 1);
        }
    }
}
</script>
<style>
.bd-callout{
    padding: 1.25rem;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    background-color: #4b9a5e;
    border-left: 0.25rem solid #28c76f;
    word-wrap: break-word;
    color: white;
}
.no-token-value{
    height: 40px;
    width: 100%;
    line-height: 50px;
    font-size: 20px;
    position: relative;
    overflow: hidden;
}
.no-token-blur{
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    background: #cdcdcdf7;
    filter: blur(9px);
}
</style>
